import clsx from 'clsx'
import { useRef } from 'react'

import mainStyles from 'assets/css/main.module.scss'
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg'
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg'
import BottomArc from 'components/bottomArc/BottomArc'
import GridCardLayout from 'components/cardGridLayout/CardGridLayout'
import { Button } from 'components/common/button/Button'
import { FrameworkWheelPage } from 'components/interactiveNavigation/FrameworkWheel'
import KeyTasks from 'components/keyTasks/KeyTasks'
import NavBar from 'components/navBar/NavBar'
import PageBanner from 'components/pageBanner/PageBanner'
import { ReturnToLandingButton } from 'components/returnToLandingButton/ReturnToLandingButton'
import { TopReturnToLandingButton } from 'components/topReturnToLandingButton/TopReturnToLandingButton'
import useHardNavigate from 'hooks/useHardNavigate'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import { ShapeBubbles, ShapeCards, ShapeKeyInputs, ShapeKeyOutputs } from './constants/ShapeConstants'
import styles from './Shape.module.scss'

const Shape = () => {
  const keyTasksRef = useRef<HTMLDivElement>(null)
  const keyPrinciplesRef = useRef<HTMLDivElement>(null)

  const hardNavigate = useHardNavigate()

  return (
    <div className={styles.Assemble}>
      <TopReturnToLandingButton />
      <PageBanner
        heading="Shape"
        description="Co-creation time! We’ve got the best partners to help shape amazing ideas to fit any market."
        showBubble
        bubbleText="Together is always better "
        backgroundStyle={{ background: 'linear-gradient(180deg, #F1E6C0 0%, #E7D394 100%)' }}
        showNavigationCircle
        bigTextFillColor="#E7D394"
        page={FrameworkWheelPage.Shape}
      />
      <NavBar
        items={[
          { key: 'key-tasks', title: 'Key Tasks', ref: keyTasksRef },
          { key: 'key-tasks', title: 'Guidance', ref: keyPrinciplesRef },
        ]}
      />
      <KeyTasks
        ref={keyTasksRef}
        color="darkYellow"
        tasks={ShapeBubbles}
        inputs={ShapeKeyInputs}
        outputs={ShapeKeyOutputs}
      />
      <div className="w-full bg-[#F4F4F4]">
        <GridCardLayout
          ref={keyPrinciplesRef}
          titleDecoration="stars"
          title="Guidance on Shape"
          cards={ShapeCards}
          decorationColor="darkYellow"
        />
      </div>
      <div className="w-full  bg-[#F4F4F4]">
        <div className={clsx(mainStyles.container)}>
          <div className="flex justify-center">
            <Button
              variant="navigationControlBlack"
              text="Go to Create"
              iconLeft={<ChevronLeft />}
              border
              className="mr-4"
              onClick={() => {
                hardNavigate('page-create')
                trackAnalytics({
                  type: AnalyticsActionType.action,
                  payload: EVENTS.ACTION.SHAPE.TO_CREATE,
                })
              }}
            />
            <ReturnToLandingButton variant="navigationControlHoverWhite" />
            <Button
              variant="navigationControlBlack"
              text="Go to Produce"
              iconRight={<ChevronRight />}
              border
              className="ml-4"
              onClick={() => {
                hardNavigate('page-produce')
                trackAnalytics({
                  type: AnalyticsActionType.action,
                  payload: EVENTS.ACTION.SHAPE.TO_PRODUCE,
                })
              }}
            />
          </div>
        </div>
      </div>
      <BottomArc backgroundColor="#F4F4F4" />
    </div>
  )
}

export default Shape
